import { apiMillennium } from '../../api'

const AwaitPayment = async () => {
	const res = await apiMillennium.get('/ag-pagamento')
	return res
}

export default AwaitPayment